import { Component, OnInit } from '@angular/core';
import {ApprovalModel} from '../../../shared/dto/approval.model';
import {UserRoleEnum} from '../../../shared/enums/user-role.enum';
import {RemarkComponent} from '../../../approval-process/remark/remark.component';
import {BlacklistApproveChecklistComponent} from '../../../blacklist-process/blacklist-approve-checklist/blacklist-approve-checklist.component';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {ReturnRemarkComponent} from '../../../approval-process/return-remark/return-remark.component';
import {FwdRemarkComponent} from '../../../approval-process/fwd-remark/fwd-remark.component';
import {ApprovalService} from '../../../service/approval.service';
import {ActivatedRoute} from '@angular/router';
import {ReversedSuspendService} from '../../../shared/service/reversed-suspend.service';
import {WorkflowEnum} from '../../../shared/enums/workflow.enum';

@Component({
  selector: 'app-reversed-suspend-authorization-request-viewer',
  templateUrl: './reversed-suspend-authorization-request-viewer.component.html',
  styleUrls: ['./reversed-suspend-authorization-request-viewer.component.scss']
})
export class ReversedSuspendAuthorizationRequestViewerComponent implements OnInit {
  appRefNo: number;
  userName: string;
  userRole: string;
  type: string;
  DG:string = UserRoleEnum.DG;
  SHO:string = UserRoleEnum.SHO;
  EXM:string = UserRoleEnum.EXM;
  approvalModel: ApprovalModel = new ApprovalModel();
  public applicantType:string;

  constructor(private route: ActivatedRoute, private tokenStorageService: TokenStorageService,
              private approvalService: ApprovalService, private modalService: NgbModal, private suspendService: ReversedSuspendService) {
    this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('id'));
      this.applicantType = params.get('type');
    });
  }

  ngOnInit() {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }
  decodeBase64(code: string): string {
    return atob(code);
  }

  rejectRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'Reject';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(RemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.applicantType
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  forwardToDg() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'FWD_DG';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(FwdRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.applicantType
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  returnRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = ActionMode.RETURN;
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReturnRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.applicantType
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  approveRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = ActionMode.APPROVE;
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;
    this.approvalModel.stage = WorkflowEnum.SUSPEND_REVERSED;

    const modalRef = this.modalService.open(BlacklistApproveChecklistComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.applicantType
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

}
